import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "enterprise-auth-page" }
const _hoisted_2 = { class: "page-panel" }
const _hoisted_3 = { class: "enterprise-auth-operation-main" }
const _hoisted_4 = { class: "enterprise-auth-control-panel" }

import { ref, reactive, computed, onUnmounted, nextTick } from "vue"
import ApplicationPage from '@/components/ApplicationPage/index.vue';
import { UploadFilled, EditPen, SuccessFilled, Loading, Document } from '@element-plus/icons-vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'enterpriseAuth',
  setup(__props) {


const _currentStep = ref(1)
const currentStep = computed({
  set: (val: number) => (_currentStep.value = Math.min(Math.max(val, 1), stepList.value.length)),
  get: () => _currentStep.value
})


const stepMaps = {
  [0]: { name: "企业认证申请", icon: Document },
  [1]: { name: "录入企业信息", icon: EditPen },
  [2]: { name: "审核", icon: Loading },
  [3]: { name: "认证完成", icon: SuccessFilled },
};
const stepList = computed(() => Object.values(stepMaps))
const stepLen = computed(() => stepList.value.length)

return (_ctx: any,_cache: any) => {
  const _component_el_step = _resolveComponent("el-step")!
  const _component_el_steps = _resolveComponent("el-steps")!

  return (_openBlock(), _createBlock(ApplicationPage, { "app-name": "企业认证" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_steps, {
              class: "enterprise-auth-operation-steps",
              "align-center": "",
              active: currentStep.value
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stepList.value, (step, index) => {
                  return (_openBlock(), _createBlock(_component_el_step, {
                    key: index,
                    title: step.name,
                    icon: step.icon
                  }, null, 8, ["title", "icon"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["active"]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", {
                class: "enterprise-auth-control-panel-arrow",
                style: _normalizeStyle({ '--step-total': stepLen.value, '--current-step': currentStep.value })
              }, null, 4),
              _createElementVNode("div", {
                onStepNext: _cache[0] || (_cache[0] = ($event: any) => (currentStep.value++)),
                onStepSet: _cache[1] || (_cache[1] = (step) => currentStep.value = step)
              }, "123123", 32)
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})